import type {
    CustomPlatformAssemblyConfig,
    CustomPlatformPropPlacementConfig,
    IndividualContentPlatformPlacementConfig,
} from './IndividualPlatformTypes'

export const level3CustomPlatformAssemblies: readonly CustomPlatformAssemblyConfig[] = []

export const level3CustomPlatformPropPlacements: readonly CustomPlatformPropPlacementConfig[] = [
    {
        name: 'Level3WindowWide01',
        platformRegion: 3,
        propAsset: 'LVL3_Window1',
        propPosition: [-30, 15, -1020],
        propRotation: [0.03, 1, -0.02],
        propScale: 3,
        platformScale: 0,
    },
    {
        name: 'Level3Paperplane01',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [-20, 17, -1045],
        propRotation: [0, -2.9, 0.15],
        propScale: 2,
        platformScale: 0,
    },
     {
        name: 'Level3Folder01',
        platformRegion: 3,
        propAsset: 'LVL3_Folder',
        propPosition: [12, 13, -1080],
        propRotation: [0, 11.5, 0.2],
        propScale: 3,
        platformScale: 0,
    },
    {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [25, 12, -1115],
        propRotation: [0, 8.5, 0.15],
        propScale: 2,
        platformScale: 0,
    },
    {
        name: 'Level3Window01',
        platformRegion: 3,
        propAsset: 'LVL3_Window2',
        propPosition: [35, 18, -1150],
        propRotation: [0.08, -0.55, 0.4],
        propScale: 3,
        platformScale: 0,
    },
    {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [12, 10, -1205],
        propRotation: [3, -2.8, -3],
        propScale: 0.5,
        platformScale: 0,
    },
     {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [22, 10, -1208],
        propRotation: [-3, 2.8, -3],
        propScale: 0.5,
        platformScale: 0,
    },
    {
        name: 'Level3Folder2',
        platformRegion: 3,
        propAsset: 'LVL3_Folder',
        propPosition: [18, 12, -1180],
        propRotation: [-0.06, 0.9, 0.03],
        propScale: 2.5,
        platformScale: 0,
    },
    {
        name: 'Level3WindowWide02',
        platformRegion: 3,
        propAsset: 'LVL3_Window1',
        propPosition: [72, 4, -1560],
        propRotation: [-0.04, -1.05, 0.04],
        propScale: 5.3,
        platformScale: 0,
    },
   
    {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [60, 24, -1605],
        propRotation: [-0.18, -1.3, 0.22],
        propScale: 4.1,
        platformScale: 0,
    },
   
    {
        name: 'Level3Folder02',
        platformRegion: 3,
        propAsset: 'LVL3_Folder',
        propPosition: [-56, -12, -1690],
        propRotation: [0.04, -0.75, -0.02],
        propScale: 5.1,
        platformScale: 0,
    },
    {
        name: 'Level3Folder03',
        platformRegion: 3,
        propAsset: 'LVL3_Folder',
        propPosition: [12, 14, -1285],
        propRotation: [-0.06, 0.9, 0.03],
        propScale: 2.5,
        platformScale: 0,
    },
    {
        name: 'Level3WindowWide02',
        platformRegion: 3,
        propAsset: 'LVL3_Window1',
        propPosition: [36, 12, -1320],
        propRotation: [0, -1, 0.1],
        propScale: 2,
        platformScale: 0,
    },
     {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [23.5, 12, -1355],
        propRotation: [0, 0, 0.5],
        propScale: 1.5,
        platformScale: 0,
    },
    {
        name: 'Level3WindowWide02',
        platformRegion: 3,
        propAsset: 'LVL3_Window2',
        propPosition: [-2, 20, -1420],
        propRotation: [0, 1, 0.1],
        propScale: 4,
        platformScale: 0,
    },
     {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [-20, 22, -1510],
        propRotation: [0.5, 0.8, 0.5],
        propScale: 3,
        platformScale: 0,
    },
    {
        name: 'Level3WindowWide02',
        platformRegion: 3,
        propAsset: 'LVL3_Window1',
        propPosition: [-12, 20, -1620],
        propRotation: [0, -1, -0.4],
        propScale: 4,
        platformScale: 0,
    },
      {
        name: 'Level3Folder03',
        platformRegion: 3,
        propAsset: 'LVL3_Folder',
         propPosition: [-12, 12, -1750],
        propRotation: [0, 0.5, -0.2],
        propScale: 2.5,
        platformScale: 0,
    },
    {
        name: 'Level3Paperplane02',
        platformRegion: 3,
        propAsset: 'LVL3_Paperplane',
        propPosition: [-10, 8, -1720],
        propRotation: [0.1, -0.15, 0],
        propScale: 3,
        platformScale: 0,
    },
   
] as const

export const level3IndividualContentPlatformPlacements: readonly IndividualContentPlatformPlacementConfig[] = []
